import { __decorate, __metadata, __param } from "tslib";
/// ref: https://confluence.zhihuiya.com/display/~wuhuinan/Release+Tips
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { format } from '@/@core/utils/string';
let ReleasePlanApi = class ReleasePlanApi {
    constructor(urls, http) {
        this.urls = urls;
        this.http = http;
    }
    /**
     * 发版计划列表查询
     */
    getReleasePlanList(params) {
        const url = this.urls.getReleasePlanList;
        return this.http.get({
            url,
            params,
        });
    }
    /**
     * 发版计划单个查询详情
     */
    getReleasePlanDetail(id) {
        const url = format(this.urls.getReleasePlanDetail, {
            id,
        });
        return this.http.get({
            url,
        });
    }
    /**
     * 新增
     */
    postReleasePlanAdd(params) {
        const url = this.urls.postReleasePlanAdd;
        return this.http.post({
            url,
            data: params,
        });
    }
    /**
     * 更新属性
     */
    putReleasePlanUpdate(params) {
        const url = this.urls.putReleasePlanUpdate;
        return this.http.put({
            url,
            data: params,
        });
    }
    /**
     * 启用禁用
     */
    patchReleasePlanSwitchEnabled(params) {
        const url = this.urls.patchReleasePlanSwitchEnabled;
        return this.http.patch({
            url,
            data: params,
        });
    }
};
ReleasePlanApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.ReleasePlanUrls)),
    __param(1, inject(Symbols.BoHttp)),
    __metadata("design:paramtypes", [Object, Object])
], ReleasePlanApi);
export { ReleasePlanApi };
